<template>
    <div>
       
        <!-- MODAL -->
          <actionmodalwide ref="mymodal"> 
            <template v-slot:body>
                <label class="titlelabel">Time Conflicts</label>
                <br>
                <label :class="textclass">{{ message }} </label>
                <br>
                <div v-for="c in timeConflictList" :key="c.id" :value="c.id" class="timegrid">
                    <label>{{ c.studentName }}</label>
                    <label>{{ c.instructorName }}</label>
                    <label>{{ c.evalStartTime }}</label>
                    <label>{{ c.evalEndTime }}</label>
                    <label>{{ c.jobName }}</label>
                </div>
                <div>
                    <smallbutton  @click="CloseWithYes" toplabel="Yes" v-if="allowConflictingTime"/>
                    <smallbutton  @click="$refs.mymodal.closeModal()" :toplabel="noLabel" v-if="allowConflictingTime"/>
                    <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Close" v-if="!allowConflictingTime"/>
                </div>
                <div>
                  <label class="responsemessage">{{responseMessage}}</label>
                </div>
            </template>
          </actionmodalwide>
        </div>
    </template>
    
    <script>
    import smallbutton from '../controls/button.vue'
    import actionmodalwide from '../controls/actionmodalwide.vue'

    export default {
        name:'confirmtimeconflict',
        components:{
            smallbutton,
            actionmodalwide,

        },
        props:{

  
            redText:{
                type:Boolean,
                default:false,
            },
            noLabel:{
                type:String,
                default:'No'
            },
            timeConflictList:{
                type:Array
            }
        },
        data(){
            return{
                responseMessage:''
            }
        },
        computed:{
            message(){
                if(this.allowConflictingTime){
                    return 'The following conflicting times have already been submitted for this date. Do you want to submit your grades and time?'
                }else{
                    return 'The following conflicting times have already been submitted for this date.'
                }
            },
            allowConflictingTime(){
                if(window.ALLOW_CONFLICTING_TIME==undefined){return true}
                else{return window.ALLOW_CONFLICTING_TIME}
            },
            buttonText(){
                if (this.buttonLabel==""){return this.title}
                else{return this.buttonLabel}
            },
            textclass(){
                if(this.redText){return "responsemessage"}
                else{return ""}
            }
        },
        methods:{
            
            Show(){
                

                this.$refs.mymodal.openModal()
            },
            async CloseWithYes(){
                this.$emit('yes')
                this.$refs.mymodal.closeModal()
            }
        }
    }
    </script>
    
    <style>
    .timegrid{
        display:grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr ;
        border:1px solid gray;
        padding: 10px;
    }
    </style>